import {
  CenturyTimePeriod,
  DayTimePeriod,
  DayWithShortMonthTimePeriod,
  DecadeTimePeriod,
  HalfDayTimePeriod,
  HalfYearTimePeriod,
  HourTimePeriod,
  HundredthSecondTimePeriod,
  MilleniaTimePeriod,
  MillisecondTimePeriod,
  MinuteTimePeriod,
  MinuteWithHoursTimePeriod,
  MonthAndYearTimePeriod,
  MonthTimePeriod,
  noText,
  QuarterHourTimePeriod,
  QuarterMinuteTimePeriod,
  QuarterYearTimePeriod,
  SecondTimePeriod,
  SecondWithMinutesAndHoursTimePeriod,
  ShortDecadeTimePeriod,
  ShortMonthAndYearTimePeriod,
  ShortYearTimePeriod,
  TenthSecondTimePeriod,
  TimeAtQuarterHourTimePeriod,
  TimeAtTwelfthHourTimePeriod,
  TimePeriod,
  TwelfthHourTimePeriod,
  TwelfthMinuteTimePeriod,
  WeekTimePeriod,
  YearTimePeriod,
} from '@shared_web/components/core/chart/time_axis/time_period';

export interface TimePeriodGroup {
  name: string;
  ticks: {main: TimePeriod; sub?: TimePeriod}[];
  group: TimePeriod;
}

const MilleniaTimePeriodGroup: TimePeriodGroup = {
  name: 'MilleniaTimePeriodGroup',
  ticks: [
    {main: CenturyTimePeriod, sub: noText(DecadeTimePeriod)},
    {main: noText(CenturyTimePeriod), sub: noText(DecadeTimePeriod)},
    {main: noText(MilleniaTimePeriod)},
  ],
  group: MilleniaTimePeriod,
};

const CenturyTimePeriodGroup: TimePeriodGroup = {
  name: 'CenturyTimePeriodGroup',
  ticks: [
    {main: DecadeTimePeriod, sub: noText(YearTimePeriod)},
    {main: ShortDecadeTimePeriod, sub: noText(YearTimePeriod)},
    {main: noText(DecadeTimePeriod), sub: noText(YearTimePeriod)},
  ],
  group: CenturyTimePeriod,
};

const DecadeTimePeriodGroup: TimePeriodGroup = {
  name: 'DecadeTimePeriodGroup',
  ticks: [{main: YearTimePeriod}, {main: ShortYearTimePeriod}, {main: noText(YearTimePeriod)}],
  group: DecadeTimePeriod,
};

const YearTimePeriodGroup: TimePeriodGroup = {
  name: 'YearTimePeriodGroup',
  ticks: [
    {main: MonthTimePeriod},
    {main: QuarterYearTimePeriod, sub: noText(MonthTimePeriod)},
    {main: HalfYearTimePeriod, sub: noText(MonthTimePeriod)},
    {main: HalfYearTimePeriod, sub: noText(QuarterYearTimePeriod)},
    {main: noText(HalfYearTimePeriod)},
  ],
  group: YearTimePeriod,
};

const MonthTimePeriodGroup: TimePeriodGroup = {
  name: 'MonthTimePeriodGroup',
  ticks: [
    {main: DayWithShortMonthTimePeriod, sub: noText(HalfDayTimePeriod)},
    {main: noText(WeekTimePeriod), sub: noText(DayTimePeriod)},
  ],
  group: MonthAndYearTimePeriod,
};

const ShortMonthTimePeriodGroup: TimePeriodGroup = {
  name: 'MonthTimePeriodGroup',
  ticks: [
    {main: DayWithShortMonthTimePeriod, sub: noText(HalfDayTimePeriod)},
    {main: noText(WeekTimePeriod), sub: noText(DayTimePeriod)},
  ],
  group: ShortMonthAndYearTimePeriod,
};

const DayTimePeriodGroup: TimePeriodGroup = {
  name: 'DayTimePeriodGroup',
  ticks: [
    {main: SecondWithMinutesAndHoursTimePeriod, sub: noText(TenthSecondTimePeriod)},
    {main: TwelfthMinuteTimePeriod, sub: noText(SecondTimePeriod)},
    {main: QuarterMinuteTimePeriod, sub: noText(TwelfthMinuteTimePeriod)},
    {main: MinuteWithHoursTimePeriod, sub: noText(QuarterMinuteTimePeriod)},
    {main: TimeAtTwelfthHourTimePeriod, sub: noText(MinuteTimePeriod)},
    {main: TimeAtQuarterHourTimePeriod, sub: noText(TwelfthHourTimePeriod)},
    {main: HourTimePeriod, sub: noText(QuarterHourTimePeriod)},
    {main: noText(DayTimePeriod)},
  ],
  group: DayTimePeriod,
};

const HourTimePeriodGroup: TimePeriodGroup = {
  name: 'HourTimePeriodGroup',
  ticks: [{main: noText(HourTimePeriod)}],
  group: HourTimePeriod,
};

const SecondTimePeriodGroup: TimePeriodGroup = {
  name: 'SecondTimePeriodGroup',
  ticks: [
    {main: MillisecondTimePeriod},
    {main: HundredthSecondTimePeriod, sub: noText(MillisecondTimePeriod)},
    {main: TenthSecondTimePeriod, sub: noText(MillisecondTimePeriod)},
  ],
  group: SecondWithMinutesAndHoursTimePeriod,
};

// Root of the logic.
// This defines a list of "ways" a time axis can be displayed.
// Each of these ways define:
// - a group (the big rectangles under the axis, the main grouping)
// - an array of possible ticks for that group (and subticks)
// The scale with try to render them all (starting by the last one) until it finds
// a group and tick that works
export const AllTimePeriodGroups = [
  MilleniaTimePeriodGroup,
  CenturyTimePeriodGroup,
  DecadeTimePeriodGroup,
  YearTimePeriodGroup,
  MonthTimePeriodGroup,
  ShortMonthTimePeriodGroup,
  DayTimePeriodGroup,
  HourTimePeriodGroup,
  SecondTimePeriodGroup,
];
